(() => {
  if (window.__naturalisticScentPickerReady) return;
  window.__naturalisticScentPickerReady = true;

  let pendingRequest;
  let liveStatus;

  function status() {
    if (!liveStatus) {
      liveStatus = document.createElement('span');
      liveStatus.className = 'visually-hidden';
      liveStatus.setAttribute('role', 'status');
      document.body.appendChild(liveStatus);
    }
    return liveStatus;
  }

  function copyHeadValue(source, selector, attribute) {
    const next = source.head.querySelector(selector);
    const current = document.head.querySelector(selector);
    if (next && current) current.setAttribute(attribute, next.getAttribute(attribute));
  }

  function updateHead(source) {
    document.title = source.title;
    copyHeadValue(source, 'link[rel="canonical"]', 'href');
    ['meta[name="description"]', 'meta[property="og:title"]',
      'meta[property="og:description"]', 'meta[property="og:url"]',
      'meta[property="og:image"]', 'meta[property="og:image:secure_url"]',
      'meta[property="og:price:amount"]'].forEach((selector) =>
      copyHeadValue(source, selector, 'content')
    );
  }

  function publishEvent(name, data) {
    if (typeof window.Shopify?.analytics?.publish !== 'function') return;
    try {
      window.Shopify.analytics.publish(name, data)?.catch?.(() => {});
    } catch (_) {
      // Analytics must never interrupt product navigation.
    }
  }

  function keepEntryOrder(currentPicker, nextPicker) {
    if (!currentPicker || !nextPicker || currentPicker.dataset.nbFamily !== nextPicker.dataset.nbFamily) return;
    const oldOrder = [...currentPicker.querySelectorAll('[data-nb-scent-link]')]
      .map((tile) => tile.dataset.nbProductHandle);
    const nextTiles = [...nextPicker.querySelectorAll('[data-nb-scent-link]')];
    const byHandle = new Map(nextTiles.map((tile) => [tile.dataset.nbProductHandle, tile]));
    const orderedTiles = oldOrder.map((handle) => {
      const tile = byHandle.get(handle);
      byHandle.delete(handle);
      return tile;
    }).filter(Boolean).concat([...byHandle.values()]);
    const visibleGrid = nextPicker.querySelector('.nb-scent-picker__grid');
    const more = nextPicker.querySelector('.nb-scent-picker__more');
    const moreGrid = more?.querySelector('.nb-scent-picker__grid');
    orderedTiles.forEach((tile, index) => {
      (index < 6 || !moreGrid ? visibleGrid : moreGrid).appendChild(tile);
    });
    if (more) {
      const wasOpen = currentPicker.querySelector('.nb-scent-picker__more')?.open;
      more.open = Boolean(wasOpen || moreGrid?.querySelector('[aria-current="page"]'));
    }
  }

  async function showProduct(url, addHistory) {
    pendingRequest?.abort();
    const request = new AbortController();
    pendingRequest = request;
    const currentMain = document.querySelector('main');
    currentMain?.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(url, { signal: request.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error('Product request failed');
      const nextPage = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextMain = nextPage.querySelector('main');
      if (!nextMain?.querySelector('product-info [data-nb-scent-picker]')) {
        throw new Error('Product picker is unavailable');
      }
      if (request.signal.aborted) return;

      keepEntryOrder(
        currentMain?.querySelector('[data-nb-scent-picker]'),
        nextMain.querySelector('[data-nb-scent-picker]')
      );

      nextMain.querySelectorAll('.scroll-trigger').forEach((node) =>
        node.classList.add('scroll-trigger--cancel')
      );
      HTMLUpdateUtility.viewTransition(currentMain, nextMain, [], [() => {
        window.Shopify?.PaymentButton?.init();
        window.ProductModel?.loadShopifyXR();
      }]);
      updateHead(nextPage);
      if (addHistory) {
        history.pushState({ ...history.state, naturalisticScent: true }, '', url);
      }
      const selected = document.querySelector('main [data-nb-scent-link][aria-current="page"]');
      selected?.focus({ preventScroll: true });
      status().textContent = 'Showing ' + (nextMain.querySelector('h1')?.textContent?.trim() || 'selected scent');
    } catch (error) {
      if (error.name !== 'AbortError') window.location.assign(url);
    } finally {
      currentMain?.removeAttribute('aria-busy');
      if (pendingRequest === request) pendingRequest = undefined;
    }
  }

  document.addEventListener('click', (event) => {
    const moreSummary = event.target.closest?.('.nb-scent-picker__more > summary');
    if (moreSummary) {
      const picker = moreSummary.closest('[data-nb-scent-picker]');
      publishEvent('naturalistic:scent_list_toggled', {
        product_handle: picker?.dataset.nbProduct,
        product_family: picker?.dataset.nbFamily,
        action: moreSummary.parentElement.open ? 'collapse' : 'expand',
      });
      return;
    }

    const link = event.target.closest?.('[data-nb-scent-link]');
    if (!link || event.defaultPrevented || event.button !== 0) return;
    const picker = link.closest('[data-nb-scent-picker]');
    publishEvent('naturalistic:scent_selected', {
      product_family: picker?.dataset.nbFamily,
      entry_product_handle: picker?.querySelector('[data-nb-scent-link]')?.dataset.nbProductHandle,
      from_product_handle: picker?.dataset.nbProduct,
      to_product_handle: link.dataset.nbProductHandle,
      from_scent: picker?.querySelector('[data-nb-scent-link][aria-current="page"]')?.dataset.nbScent,
      to_scent: link.dataset.nbScent,
      position: [...picker.querySelectorAll('[data-nb-scent-link]')].indexOf(link) + 1,
      area: link.closest('details') ? 'see_all' : 'initial_six',
    });
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey ||
        link.target || typeof HTMLUpdateUtility === 'undefined' || window.Shopify?.designMode) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || url.pathname === window.location.pathname) return;
    event.preventDefault();
    showProduct(url.href, true);
  });

  window.addEventListener('popstate', () => {
    const shownPath = document.querySelector('main product-info')?.dataset.url;
    if (shownPath && window.location.pathname.startsWith('/products/') &&
        shownPath !== window.location.pathname) {
      showProduct(window.location.href, false);
    }
  });
})();
